// @flow
import * as React from 'react';
import { Box, Text } from 'grommet';
import { CheckBox as GrommetCheckbox } from 'grommet/components/CheckBox/CheckBox';
import { debounce } from 'lodash';
import ApiClient from 'speed-js-core/src/api/ApiClient';
import type { Map } from 'esm-web-pro/containers/map/types';
import connectAPI from 'speed-js-react/src/api/connectAPI';
import { MapContext } from 'esm-web-pro/containers/map/context';
import { FormattedMessage } from 'react-intl';


type Props = {
    provider: {
        entity: {
            name: string,
        },
    },
    lines: Array<Object>,
    checkEITExport: Function,
    value: boolean,
    // eslint-disable-next-line react/no-unused-prop-types
    onEitExportChange: Function,
};

const debouncedCallback = debounce((callback, parameters) => callback(...parameters), 250);

const CableEitExport = (props: Props) => {
    const {
        lines, provider, checkEITExport, value,
    } = props;

    let providerName;
    if (provider) {
        providerName = provider?.entity?.name || provider;
    }

    const map = React.useContext(MapContext);

    React.useEffect(() => {
        //  EIT Export is true:
        //  1. if the cable provider is ESM WEB PRO
        //  2. all cable paths lines are pipes
        //  3. all cable paths pipes are EIT Export = True
        if (providerName !== process.env.REACT_APP_DEFAULT_PROVIDER) return;

        if (lines.length > 0) {
            // debounce checkEITExport because the useEffect is triggered not only when new
            // line is added but if some of the properties of the lines are changed and
            // because of that the function is called multiple times
            debouncedCallback(checkEITExport, [map, lines.map((line) => line.value)]);
        }
    }, [lines.length]);

    return null;
    // return (
    //     <Box flex={false} margin={{ vertical: 'small' }}>
    //         <GrommetCheckbox
    //             name="cable-export-name"
    //             checked={value}
    //             label={(
    //                 <Text>
    //                     <FormattedMessage id="cable-export" defaultMessage="EIT Export" />
    //                 </Text>
    //             )}
    //             disabled
    //         />
    //     </Box>
    // );
};

const apiCallback = (apiClient: ApiClient, props: Props) => ({
    checkEITExport: {
        send: (map: Map, pipes: Array<string>) => apiClient.resources['cable.geo'].checkEITExport(map.uuid, { pipes }),
        success: (res) => props.onEitExportChange(res),
    },
});

export default connectAPI(apiCallback)(CableEitExport);
